import {
  DETECTED_ISSUE_TYPE_TO_URGENCY,
  DETECTED_ISSUE_TYPES,
  type DetectedIssueType,
  type DetectedIssueUrgency,
} from '../moderation'

export function getDetectedIssueTypesWithUrgencies(
  urgencies: DetectedIssueUrgency[]
): DetectedIssueType[] {
  return DETECTED_ISSUE_TYPES.filter(type =>
    urgencies.includes(DETECTED_ISSUE_TYPE_TO_URGENCY[type])
  )
}
